import appConfig from '../config/appConfig';
import UWM_COMMAND_TYPES from '../consts/uwm/uwmCommendTypes';
import {selectIotDeviceMaterialColor, selectIotDeviceType} from '../state/selectors/iotDevice';
import {getState} from '../state/store';
import {getMappedInitialLanguageCode} from './localization/localizationService';
import marketTypeService from './marketTypeService';

const postMessage = (detail) => {
    document.getElementById('uwmIframe').contentWindow.postMessage({detail}, '*');
};

const postTipsAndTutorialsInitMessage = ({isQuickStartGuide, isCleaningGuide, deviceType, skipFirstStep}) => {
    const materialColor = selectIotDeviceMaterialColor(getState());

    postMessage({
        command: UWM_COMMAND_TYPES.UWM_INIT_TIPS_TUTORIALS,
        payload: {
            deviceType: deviceType || selectIotDeviceType(getState()),
            materialColor,
            isQuickStartGuide,
            isCleaningGuide,
            skipFirstStep,
            platformCode: 'WEB',
        },
    });
};

const postMarketLocaleInitMessage = () => {
    const isDCE2 = marketTypeService.isDCE2();
    const countryCode = isDCE2 ? appConfig.getMuleSoftCountryCode() : appConfig.getIccApiHeader_m();
    const languageCode = getMappedInitialLanguageCode()?.toUpperCase();

    postMessage({
        command: UWM_COMMAND_TYPES.UWM_INIT_MARKET_LOCALE,
        payload: {
            countryCode,
            languageCode,
        },
    });
};

export default {
    postTipsAndTutorialsInitMessage,
    postMarketLocaleInitMessage,
};
